import Vue from 'vue'
import VueRouter from 'vue-router'
import Applayout from "@/layout/app";
import { useAuthStore } from '@/stores';
import { useMeta } from 'vue-meta';
import NotFound from '@/views/NotFound.vue';

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        component: Applayout,
        children: [
            {
                path: "/",
                name: "메인",
                component: () => import("./views/app/index"),
                meta: { auth: false, title: '메인화면', subTitle:'',
                    metaTags: [
                        { name: 'title', content: '사업자DB,기업DB,법인DB,DB판매,DB업체' },
                        { name: 'description', content: '영업에 필요한 사업자DB 를 쉽고 간편하게! 매일 업데이트되는 업종별 최신 신규사업자DB 를 DB365 에서 확인하세요! [사업자 전화번호, DB업체, DB판매, DB구매]' },
                    ] }
            },
            {
                path: "database/:type",
                name: "database",
                component: () => import("./views/app/database"),
                meta: { auth: false, title: 'database',subTitle:'',
                    metaTags: [
                        { name: 'title', content: "" },
                        { name: 'description', content: '' },
                    ]}
            },
            {
                path: "faq",
                name: "faq",
                component: () => import("./views/app/faq"),
                meta: { auth: false, title: 'faq',subTitle:'' }
            },
            {
                path: "license",
                name: "license",
                component: () => import("./views/app/license_back"),
                meta: { auth: false, title: 'license',subTitle:'' }
            },
            {
                path: "mypage",
                name: "mypage",
                component: () => import("./views/app/myPage"),
                meta: { auth: true, title: 'mypage',subTitle:'' }
            },
            {
                path: "mydelete",
                name: "mydelete",
                component: () => import("./views/app/myDelete"),
                meta: { auth: true, title: 'mydelete',subTitle:'' }
            },
            {
                path: "myupdate",
                name: "myupdate",
                component: () => import("./views/app/myUpdate"),
                meta: { auth: true, title: 'myUpdate',subTitle:'' }
            },
            {
                path: "contact-us",
                name: "notice",
                component: () => import("./views/app/notice"),
                meta: { auth: false, title: 'notice',subTitle:'',
                    metaTags: [
                        { name: 'title', content: '고객센터' },
                        { name: 'description', content: 'DB365의 고객센터입니다. 문의사항이 있으시면 언제든 이메일이나 전화로 연락주시면 친절하게 답변해 드리겠습니다.' },
                    ]}
            },
            {
                path: "noticeDetail",
                name: "noticeDetail",
                component: () => import("./views/app/noticeDetail"),
                meta: { auth: false, title: 'noticeDetail',subTitle:'' }
            },
            {
                path: "signup",
                name: "signup",
                component: () => import("./views/app/signup"),
                meta: { auth: false, title: 'signup',subTitle:'' },
            },
            {
                path: "lostAccount",
                name: "lostAccount",
                component: () => import("./views/app/lostAccount"),
                meta: { auth: false, title: 'lostAccount',subTitle:'' },
            },
            {
                path: "logout",
                name: "logout",
                component: () => import("./views/app/logout"),
                meta: { auth: true, title: 'logout',subTitle:'' },
            },
            {
                path: "portal",
                name: "portal",
                component: () => import("./views/app/portal"),
                meta: { auth: false, title: 'portal',subTitle:'', canonical: 'https://db365.co.kr/portal',
                    metaTags: [
                        { name: 'title', content: '포털 DB' },
                        { name: 'description', content: '포털디비는 매일 실시간으로 업데이트 되고 있습니다. 영업에 필요한 개인사업자DB, 신규사업자DB, 영업DB가 필요하시다면 포털DB를 이용해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("포털DB"),
                redirect: "/portal",
            },
            {
                path: "permitting",
                name: "permitting",
                component: () => import("./views/app/permitting"),
                meta: { auth: false, title: 'permitting',subTitle:'', canonical: 'https://db365.co.kr/permitting',
                    metaTags: [
                        { name: 'title', content: '인허가 DB' },
                        { name: 'description', content: '인허가 DB는 여러 공식 기관에서 인허가가 된 사업자 DB를 뜻합니다. 최신사업자DB, 기업DB, 법인DB가 필요하시면 인허가DB를 이용해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("인허가DB"),
                redirect: "/permitting",
            },
            {
                path: "corporation",
                name: "corporation",
                component: () => import("./views/app/corporation"),
                meta: { auth: false, title: 'corporation',subTitle:'', canonical: 'https://db365.co.kr/corporation',
                    metaTags: [
                        { name: 'title', content: '법인 DB' },
                        { name: 'description', content: '법인DB를 찾으시나요? 영업에 필요한 이메일, 팩스, 전화번호 등 전국에 있는 법인 사업자DB를 실시간으로 제공하고 있습니다. 법인정보가 필요하신 분은 법인디비를 이용해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("법인DB"),
                redirect: "/corporation",
            },
            {
                path: "market",
                name: "market",
                component: () => import("./views/app/market"),
                meta: { auth: false, title: 'market',subTitle:'', canonical: 'https://db365.co.kr/market',
                    metaTags: [
                        { name: 'title', content: '마켓 DB' },
                        { name: 'description', content: '마켓DB는 각종 신뢰성이 높은 마켓에 해당하는 사업자DB 입니다. 영업에 필요한 신규사업자DB, 전국 업종별 사업자DB가 필요하시다면 마켓DB를 이용해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("마켓DB"),
                redirect: "/market",
            },
            {
                path: "phone",
                name: "phone",
                component: () => import("./views/app/phone"),
                meta: { auth: false, title: 'phone',subTitle:'', canonical: 'https://db365.co.kr/phone',
                    metaTags: [
                        { name: 'title', content: '휴대폰 DB' },
                        { name: 'description', content: '휴대폰 DB를 찾으시나요? 휴대폰 디비는 사업자, 법인사업자 등의 DB에 전화번호가 포함된 DB를 뜻합니다. 지금 바로 DB365에서 확인해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("휴대폰DB"),
                redirect: "/phone",
            },
            {
                path: "fax",
                name: "fax",
                component: () => import("./views/app/fax"),
                meta: { auth: false, title: 'fax',subTitle:'', canonical: 'https://db365.co.kr/fax',
                    metaTags: [
                        { name: 'title', content: '팩스 DB' },
                        { name: 'description', content: '팩스 DB를 찾으시나요? 팩스 디비는 사업자, 법인사업자 등의 DB에 팩스가 포함된 DB를 뜻합니다. 지금 바로 DB365에서 확인해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("팩스DB"),
                redirect: "/fax",
            },
            {
                path: "email",
                name: "email",
                component: () => import("./views/app/email"),
                meta: { auth: false, title: 'email',subTitle:'', canonical: 'https://db365.co.kr/email',
                    metaTags: [
                        { name: 'title', content: '이메일 DB' },
                        { name: 'description', content: '이메일 DB를 찾으시나요? 이메일 디비는 사업자, 법인사업자 등의 DB에 이메일이 포함된 DB를 뜻합니다. 지금 바로 DB365에서 확인해보세요.' },
                    ]},
            },
            {
                path: encodeURIComponent("이메일DB"),
                redirect: "/email",
            },
            {
                path: "company",
                name: "company",
                component: () => import("./views/app/company"),
                meta: { auth: false, title: 'company',subTitle:'', canonical: 'https://db365.co.kr/company',
                    metaTags: [
                        { name: 'title', content: '기업 DB' },
                        { name: 'description', content: '기업DB는 여러 신뢰성이 높은 상장 법인기업, 중소기업DB 뜻합니다. 기업 이메일DB, 팩스DB, 법인정보 등 영업에 필요한 회사DB를 빠르게 찾으세요."' },
                    ]},
            },
            {
                path: encodeURIComponent("기업DB"),
                redirect: "/company",
            },
            {
                path: "term1",
                name: "term1",
                component: () => import("./views/app/term1"),
                meta: { auth: false, title: 'term1',subTitle:'' }
            },
            {
                path: "term2",
                name: "term2",
                component: () => import("./views/app/term2"),
                meta: { auth: false, title: 'term2',subTitle:'' }
            },
            {
                path: "database/:type",
                name: "database",
                component: () => import("./views/app/database"),
                meta: { auth: false, title: 'database',subTitle:'' }
            },
            {
                path: "pgResult",
                name: "pgResult",
                component: () => import("./views/app/pgResult"),
                meta: { auth: false, title: 'pgResult', subTitle: '' }
            }
        ]
    },
    {
        path: "/:catchAll(.*)",  // 모든 경로를 처리
        component: NotFound
    }
]

const router = new VueRouter({
    linkActiveClass: 'active',
    routes,
    mode: 'history',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
})



// router.beforeEach((to, from, next) => {
//
//     /* 2️⃣ 기존 meta 제거 */
//     document
//         .querySelectorAll('[data-vue-meta]')
//         .forEach(el => el.remove())
//
//     /* 3️⃣ metaTags 처리 (절대 원본 수정 금지) */
//     if (to.meta?.metaTags) {
//         to.meta.metaTags.forEach(originalTag => {
//
//             const tag = { ...originalTag } // ⭐ 복사본 사용
//             const metaTag = document.createElement('meta')
//
//             if (to.name === 'database') {
//                 if (tag.name === 'title') {
//                     tag.content = `${to.params.type} DB`
//                 }
//                 if (tag.name === 'description') {
//                     tag.content = `${to.params.type} DB를 찾으시나요? ${to.params.type} 디비는 전국의 ${to.params.type} 사업자, 법인사업자, 주소, 전화번호 등이 포함된 DB를 뜻합니다. 지금 바로 DB365에서 확인해보세요.`
//                 }
//             }
//
//             if (tag.name === 'title') {
//                 document.title = `${tag.content} | 디비365`
//             } else {
//                 metaTag.setAttribute('name', tag.name)
//                 metaTag.setAttribute('content', tag.content)
//                 metaTag.setAttribute('data-vue-meta', 'true')
//                 document.head.appendChild(metaTag)
//             }
//         })
//     }
//
//     /* 4️⃣ auth 여부는 matched 기준 */
//     const requiresAuth = to.matched.some(
//         record => record.meta?.auth === true
//     )
//
//     if (!requiresAuth) {
//         next()
//         return
//     }
//
//     /* 5️⃣ 인증 체크 */
//     const auth = useAuthStore()
//     if (!auth.accessToken) {
//         next({ path: '/' }) // 홈은 auth:false라 안전
//         return
//     }
//
//     next()
// })
router.beforeEach((to, from, next) => {

    const requiresAuth = to.matched.some(
        record => record.meta?.auth === true
    )

    if (!requiresAuth) {
        next()
        return
    }

    const auth = useAuthStore()

    if (!auth.accessToken) {
        next({ path: '/' })
        return
    }

    next()
})

router.afterEach((to) => {

    // 기존 meta 제거
    document
        .querySelectorAll('[data-vue-meta]')
        .forEach(el => el.remove())

    if (to.meta?.metaTags) {
        to.meta.metaTags.forEach(originalTag => {

            const tag = { ...originalTag }
            const metaTag = document.createElement('meta')

            if (to.name === 'database') {
                if (tag.name === 'title') {
                    tag.content = `${to.params.type} DB`
                }
                if (tag.name === 'description') {
                    tag.content =
                        `${to.params.type} DB를 찾으시나요? ${to.params.type} 디비는 전국의 ${to.params.type} 사업자, 법인사업자, 주소, 전화번호 등이 포함된 DB를 뜻합니다. 지금 바로 DB365에서 확인해보세요.`
                }
            }

            if (tag.name === 'title') {
                document.title = `${tag.content} | 디비365`
            } else {
                metaTag.setAttribute('name', tag.name)
                metaTag.setAttribute('content', tag.content)
                metaTag.setAttribute('data-vue-meta', 'true')
                document.head.appendChild(metaTag)
            }
        })
    }

    // 🔥 canonical 추가
    let link = document.querySelector("link[rel='canonical']")
    if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
    }

    link.setAttribute(
        'href',
        to.meta?.canonical || (window.location.origin + to.fullPath)
    )
})

export default router;